import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRouteMatch, Route, Switch, useHistory, useParams } from "react-router-dom";
import _ from "lodash";
import cx from "classnames";

import { getBaseUrl } from "services/util";
import { renderStepComponent, getStepConfig } from "./stepRenderer";

import styles from "./storyboardCreation.module.scss";

export default function StoryboardCreationPageView() {
    const { path } = useRouteMatch();
  
    return (
      <Switch>
        <Route path={`${path}/folder/:listId`}>
          <StoryboardCreationPage />
        </Route>
        <Route exact path={path}>
          <StoryboardCreationPage />
        </Route>
      </Switch>
    );
}

export function StoryboardCreationPage() {
    const dispatch = useDispatch();
    const history = useHistory();
    let { url } = useRouteMatch();
    let baseUrl = getBaseUrl(url);
    const { listId } = useParams();
    

    // Use useState for currentStep (local state)
    const [currentStep, setCurrentStep] = useState(1);
    const [vibe, setVibe] = useState('Minimalism');
    // Get data from Redux
    const promptCreation = useSelector(state => 
        _.get(state, "promptEditor", {})
    );

    // Transition state management
    const [transitionState, setTransitionState] = useState({
        currentStep: currentStep,
        previousStep: null,
        isTransitioning: false,
        direction: 'forward' // 'forward' or 'backward'
    });
    const previousStepRef = useRef(currentStep);

    // Get step configuration
    const stepConfig = getStepConfig(currentStep);

    // Handle step changes and transitions
    useEffect(() => {
        if (currentStep !== previousStepRef.current) {
            if (currentStep === 3) {
                setVibe('Minimalism');
            }
            
            const direction = currentStep > previousStepRef.current ? 'forward' : 'backward';
            
            setTransitionState({
                previousStep: previousStepRef.current,
                currentStep: currentStep,
                isTransitioning: true,
                direction
            });

            // End transition after animation completes
            const transitionTimeout = setTimeout(() => {
                setTransitionState(prev => ({
                    ...prev,
                    isTransitioning: false
                }));
            }, 400); // Match CSS animation duration

            previousStepRef.current = currentStep;

            return () => clearTimeout(transitionTimeout);
        }
    }, [currentStep]);

    // No longer needed - StoryLineStep now handles loading state internally

    // Handle refresh redirect - if no prompt data exists, redirect to base URL
    // useEffect(() => {
    //     if (!promptCreation.prompt && currentStep === 1) {
    //         // Check if user came from direct URL without starting flow
    //         const hasNoData = !promptCreation.prompt && 
    //                          !promptCreation.outline && 
    //                          !promptCreation.vibe && 
    //                          !promptCreation.template;
            
    //         if (hasNoData) {
    //             history.push(`${baseUrl}/storyboards`);
    //         }
    //     }
    // }, []);

    const handleBackClick = () => {
        if (currentStep === 1) {
            // If on step 1, go back to storyboards list
            const url = listId
                ? `${baseUrl}/storyboards/folder/${listId}`
                : `${baseUrl}/storyboards`;
            history.push(url); 
        } else {
            // Go back to previous step
            setCurrentStep(currentStep - 1);
        }
    };

    // Function to update step (passed to step components)
    const updateStep = (step) => {
        setCurrentStep(step);
    };

    const updateVibe = (data) => {
        setVibe(data);
    };

    // Props to pass to step components
    const stepProps = {
        baseUrl,
        promptCreation,
        onBack: handleBackClick,
        currentStep,
        updateStep,
        vibe,
        updateVibe
    };

    // Determine transition classes
    const getTransitionClasses = () => {
        const classes = [styles.stepContent];
        
        if (transitionState.isTransitioning) {
            if (transitionState.direction === 'forward') {
                classes.push(styles.entering);
            } else {
                classes.push(styles.enteringBackward);
            }
        } else {
            classes.push(styles.active);
        }

        return cx(classes);
    };

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.transitionContainer}>
                <div 
                    key={currentStep} 
                    className={getTransitionClasses()}
                >
                    {renderStepComponent(currentStep, stepProps)}
                </div>
            </div>
        </div>
    );
}